import window from './window';
/**
 * This regex matches the following:
 * $1 The app name (student, parent, counselor, admissions)
 * $2 The college profile path
 * @example running match using this regex on /student/colleges/123/student-life?someParam=true
 * will return the following:
 * [
 *  0: "/student/colleges/123/student-life",
  * 1: "/"
  * 2: "student",
  * 3: "/colleges/123/student-life"
 * ]
 */
export const matchRegex = new RegExp(`(^\/)([a-z]+)(/colleges/[0-9]+/[a-z-]+)`, 'i');
/**
 * Call redirectToBestAppForCollegeProfile in student, parent, counselor, and admissions apps
 * to redirect to the same page in the other app where you're signed in
 *
 * For example, if you're signed in to the student app and you navigate to
 * https://app.scoir.com/admissions/colleges/123/student-life?someParam=true, you'll be redirected to
 * https://app.scoir.com/student/colleges/123/student-life?someParam=true
 *
 * @returns void
 */
export const redirectHandler = (appToShow) => {
    const l = window.location;
    const domain = l.origin;
    const pathname = l.pathname;
    const search = l.search;
    const matches = pathname.match(matchRegex);
    if (matches) { // if we're on a college profile page, we can find an app to go to if we're not signed in
        // this is the app name in the current pathname
        const appInPathname = matches[2];
        // don't redirect if we're signed into this app
        if (appToShow !== appInPathname) {
            // Navigate to the same page in the other app where you're signed in
            const path = pathname.replace(matchRegex, `$1${appToShow}$3`);
            return `${domain}${path}${search}`;
        }
    }
    return '';
};
